// src/utils/sectionFieldMap.js

const sectionFieldMap = {
  section1: [
    "firstName",
    "lastName",
    "middleName",
    "dob",
    "gender",
    "email",
    "phone",
    "address",
    "city",
    "state",
    "zip",
    "country",
  ],

  section2: [
    "emergencyContactName",
    "emergencyContactRelation",
    "emergencyContactPhone",
    "emergencyContactEmail",
  ],

  section3: [
    "passportNumber",
    "passportIssueDate",
    "passportExpiryDate",
    "passportIssuedCountry",
    "nationality",
  ],

  section4: [
    "healthConditions",
    "allergies",
    "medications",
    "specialAssistance",
  ],

  section5: ["outboundFlights", "inboundFlights"],

  section6: ["Category", "isKnownUser", "roommateName", "roommateEmail"],
};

export default sectionFieldMap;
